<template>
  <div class="ui container">
    <div style="text-align: center;">
      <div>Buy Load For</div>
      <div>{{ phoneNumber }}</div>
    </div>
    <div class="ui secondary pointing menu">
      <a class="item active">
        REGULAR
      </a>
      <a class="item">
        LOAD WITH FREEBIE
      </a>
      <a class="item">
        SURF
      </a>
    </div>
    <div class="ui middle aligned divided list">
      <div class="item" v-for="regular in regularLoads" :key="regular">
        <div class="ui radio checkbox right floated content">
          <input type="radio" name="radio" checked="checked" :value="regular" v-model="chosenLoad">
          <label></label>
        </div>
        <img class="ui avatar image" src="https://picsum.photos/id/294/200/200">
        <div class="content">
          Regular Load ₱{{ regular }}
        </div>
      </div>
    </div>
    <div class="button-div">
      <button class="ui fluid primary button" @click="next">
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      phoneNumber: '',
      regularLoads: ['10.00', '15.00', '20.00', '30.00', '50.00'],
      chosenLoad: ''
    }
  },
  mounted () {
    this.phoneNumber = this.$route.params.phone_number
  },
  methods: {
    next () {
      console.log(this.chosenLoad)

      this.$router.push({
        name: 'Cashier',
        params: {
          phone_number: this.phoneNumber,
          chosen_load: this.chosenLoad
        }
      })
    }
  }
}
</script>

<style scoped>
.button-div {
  margin-top: 20px;
}

button {
  border-radius: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BuyLoad/SelectLoadType.vue